export default "__VITE_ASSET__DknkP$_N__"